// extracted by mini-css-extract-plugin
export default {"wrapper":"CancelOrder_wrapper__BcTs+","headerText":"CancelOrder_headerText__tH-0m","message":"CancelOrder_message__FCiDD","btnConfirm":"CancelOrder_btnConfirm__GVh4m"};